import { getSiteIdsForGroups } from "@/utils/store";

const DEFAULT_STATE = {
  sites: [],
  siteGroups: [],

  // VisitorsData :
  dates: [],
  containsText: "",
  flavour: "",
  region: "",
  ageSlot: "",

  // Marmiton :
  marmitonPeriod: 0,
  marmitonDates: [],
  marmitonIngredientsToInclude: [],
  marmitonUtensilsToInclude: [],
  marmitonIngredientsToExclude: [],
  marmitonTopIngredientsToExclude: [],
  marmitonStatsForPeriod: {},
  marmitonSearchText: "",
  rates: 0,
  rating: -1,
  cost: "",
  dish: "",
  duration: 0,
};

export default {
  namespaced: true,
  state: {
    ...DEFAULT_STATE,
  },
  getters: {
    getSites: (state) => state.sites,
    getSiteGroups: (state) => state.siteGroups,

    // VisitorsData :
    getDates: (state) => {
      // always return the dates ordered
      return state.dates[0] < state.dates[1]
        ? [state.dates[0], state.dates[1]]
        : [state.dates[1], state.dates[0]];
    },
    getContainsText: (state) => state.containsText,
    getFlavour: (state) => state.flavour,
    getRegion: (state) => state.region,
    getAgeSlot: (state) => state.ageSlot,

    // Marmiton :
    getMarmitonPeriod: (state) => state.marmitonPeriod,
    getMarmitonDates: (state) => {
      // always return the dates ordered
      return state.marmitonDates[0] < state.marmitonDates[1]
        ? [state.marmitonDates[0], state.marmitonDates[1]]
        : [state.marmitonDates[1], state.marmitonDates[0]];
    },
    getMarmitonIngredientsToInclude: (state) =>
      state.marmitonIngredientsToInclude,
    getMarmitonUtensilsToInclude: (state) => state.marmitonUtensilsToInclude,
    getMarmitonIngredientsToExclude: (state) =>
      state.marmitonIngredientsToExclude,
    getMarmitonTopIngredientsToExclude: (state) =>
      state.marmitonTopIngredientsToExclude,
    getMarmitonStatsForPeriod: (state) => state.marmitonStatsForPeriod,
    getMarmitonSearchText: (state) => state.marmitonSearchText,
    getRates: (state) => state.rates,
    getRating: (state) => state.rating,
    getCost: (state) => state.cost,
    getDish: (state) => state.dish,
    getDuration: (state) => state.duration,
  },
  mutations: {
    initState(state) {
      for (const [key, value] of Object.entries(DEFAULT_STATE)) {
        state[key] = value;
      }
    },
    setSites(state, payload) {
      state.sites = payload;
    },
    setSiteGroups(state, payload) {
      state.siteGroups = payload;
    },

    // VisitorsData :
    setDates(state, payload) {
      state.dates = payload;
    },
    setContainsText(state, payload) {
      state.containsText = payload;
    },
    setFlavour(state, payload) {
      state.flavour = payload;
    },
    setRegion(state, payload) {
      state.region = payload;
    },
    setAgeSlot(state, payload) {
      state.ageSlot = payload;
    },

    // Marmiton :
    setMarmitonPeriod(state, payload) {
      state.marmitonPeriod = payload;
    },
    setMarmitonDates(state, payload) {
      state.marmitonDates = payload;
    },
    setMarmitonIngredientsToInclude(state, payload) {
      state.marmitonIngredientsToInclude = payload;
    },
    setMarmitonUtensilsToInclude(state, payload) {
      state.marmitonUtensilsToInclude = payload;
    },
    setMarmitonIngredientsToExclude(state, payload) {
      state.marmitonIngredientsToExclude = payload;
    },
    setMarmitonTopIngredientsToExclude(state, payload) {
      state.marmitonTopIngredientsToExclude = payload;
    },
    setMarmitonStatsForPeriod(state, payload) {
      state.marmitonStatsForPeriod = payload;
    },
    setMarmitonSearchText(state, payload) {
      state.marmitonSearchText = payload;
    },
    setRates(state, payload) {
      state.rates = payload;
    },
    setRating(state, payload) {
      state.rating = payload;
    },
    setCost(state, payload) {
      state.cost = payload;
    },
    setDish(state, payload) {
      state.dish = payload;
    },
    setDuration(state, payload) {
      state.duration = payload;
    },
  },
  actions: {
    initState({ commit }) {
      commit("initState");
    },
    updateSites({ commit }, payload) {
      commit("setSites", payload);
    },
    async updateSiteGroups({ commit }, payload) {
      commit("setSiteGroups", payload);

      const site_ids = await getSiteIdsForGroups(payload);
      commit("setSites", site_ids);

      return site_ids;
    },

    // VisitorsData :
    updateDates({ commit }, payload) {
      if (payload.length >= 2) {
        commit("setDates", payload);
      }
    },
    updateContainsText({ commit }, payload) {
      commit("setContainsText", payload);
    },
    updateFlavour({ commit }, payload) {
      commit("setFlavour", payload);
    },
    updateRegion({ commit }, payload) {
      commit("setRegion", payload);
    },
    updateAgeSlot({ commit }, payload) {
      commit("setAgeSlot", payload);
    },

    // Marmiton :
    updateMarmitonPeriod({ commit }, payload) {
      commit("setMarmitonPeriod", payload);
    },
    updateMarmitonDates({ commit }, payload) {
      if (payload.length >= 2) {
        commit("setMarmitonDates", payload);
      }
    },
    updateMarmitonIngredientsToInclude({ commit }, payload) {
      commit("setMarmitonIngredientsToInclude", payload);
    },
    updateMarmitonUtensilsToInclude({ commit }, payload) {
      commit("setMarmitonUtensilsToInclude", payload);
    },
    updateMarmitonIngredientsToExclude({ commit }, payload) {
      commit("setMarmitonIngredientsToExclude", payload);
    },
    updateMarmitonTopIngredientsToExclude({ commit }, payload) {
      commit("setMarmitonTopIngredientsToExclude", payload);
    },
    updateMarmitonStatsForPeriod({ commit }, payload) {
      commit("setMarmitonStatsForPeriod", payload);
    },
    updateMarmitonSearchText({ commit }, payload) {
      commit("setMarmitonSearchText", payload);
    },
    updateRates({ commit }, payload) {
      commit("setRates", payload);
    },
    updateRating({ commit }, payload) {
      commit("setRating", payload);
    },
    updateCost({ commit }, payload) {
      commit("setCost", payload);
    },
    updateDish({ commit }, payload) {
      commit("setDish", payload);
    },
    updateDuration({ commit }, payload) {
      commit("setDuration", payload);
    },
  },
};
